import type { InvokeDefinition } from '../../signalr/types'
import {
  getDefaultSecurityFilter,
  getTickerAndMaturity
} from '../securities/helpers'
import {
  type HasNsKey,
  getShowLive,
  getWatchlistId
} from '../securities/selectors'
import {
  type SearchSecuritiesAction,
  searchSecuritiesFailure,
  searchSecuritiesSuccess
} from './actions'
import { createSecuritySearchResultFromResponse } from './helpers'

export const searchSecuritiesDefinition: InvokeDefinition<
  [string, any],
  any[],
  SearchSecuritiesAction,
  HasNsKey
> = {
  method: 'SearchSecurities',
  strategy: 'switch',
  getParams: (state, action) => {
    const { gridIndex, query, ignoreWatchlist } = action.payload
    const watchlistId = getWatchlistId(state)(gridIndex)
    const inWatchlistId = ignoreWatchlist ? undefined : watchlistId
    const notInWatchlistId = ignoreWatchlist ? watchlistId : undefined
    const isShowLiveChecked = getShowLive(state)(gridIndex)
    const filters = {
      ...getDefaultSecurityFilter(),
      InWatchlistId: inWatchlistId,
      NotInWatchlistId: notInWatchlistId,
      showLive: isShowLiveChecked,
      ...getTickerAndMaturity(query)
    }
    return [query, filters]
  },
  mapResponse: (securityResponses, action) => {
    const securities = securityResponses.map(
      createSecuritySearchResultFromResponse
    )
    return searchSecuritiesSuccess(
      action.payload.gridIndex,
      securities,
      action.payload.ignoreWatchlist
    )
  },
  mapError: (err, action) =>
    searchSecuritiesFailure(action.payload.gridIndex, err)
}
